import React from 'react';
import { useTranslator } from '@front-activerse/common-components';
import Odometer from 'react-odometerjs';

const HydrationDayProgress = ({ unit, value, goal }) => {
  const { t } = useTranslator();

  const percentage = (value / goal) * 553;

  return (
    <div className="hydration-progress-wrapper">
      <div className="hydration-chart">
        <svg className="svg-donut" width="200px" height="200px">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <circle
              className="donut"
              strokeDasharray={`${percentage}, 900`}
              stroke="#FF3B30"
              strokeWidth="24"
              strokeLinecap="round"
              transform="translate(100.000000, 100.000000) scale(1, -1) translate(-100.000000, -100.000000) "
              cx="100"
              cy="100"
              r="88"
              style={{
                '--endvalue': percentage,
              }}
              data-testid="hydration-chart-circle"
            ></circle>
          </g>
        </svg>

        <div className="text">
          <span className="current-value">
            <Odometer value={value} format="d" /> {unit}
          </span>
          <br />
          {t('hydration.chart.goalInfo', { goal, unit })}
        </div>
      </div>
    </div>
  );
};

export default HydrationDayProgress;
